<template>
  <v-container fluid pa-0 ma-0 fill-height style="background-color: white;">
    <v-layout column wrap fill-height class="mx-3" justify-center align-center>
      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.replace({ name: 'EmailLogin' })">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
  <!--      <h3 class="display-2" style="margin-bottom: 2px"></h3>-->
      </v-toolbar>

      <div class="pb-5">
        <div class="mb-2" style="font-weight: 700; font-size: 20px; letter-spacing: -0.3px; color: black;">
          가입이 완료되었습니다!
        </div>
        <div class="mb-5" style="font-size: 12px; line-height: 18px;">
          입력하신 이메일로 인증메일을 발송했습니다.<br>
          메일 확인 후 서비스를 이용해주세요!
        </div>
        <div>
          <v-img class="ma-auto" :src="require('@/assets/img/yuni-congratulations.png')" width="151px"></v-img>
        </div>
      </div>

      <div style="width: 100%;" class="px-4 pt-5">
        <v-btn block depressed color="primary" class="button-style" @click="$router.replace({ name: 'EmailLogin' })">
          확인
        </v-btn>
      </div>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'EmailConfirm'
  }
</script>

<style lang="scss" scoped>
  .button-style {
    height: 56px;
    font-size: 14px;
    letter-spacing: -0.3px;
  }

</style>
